import { baseUrl, baseUrlWithoutApi } from '../../../baseurl';
import { create } from 'zustand';
import axios from 'axios';
import Loader from '../../../components/Loader/Loader';


export const useUserInfo = create((set, get) => ({
    userInfo: [],
    userInfoWithMobile: [],
    loader: false,
    isSuccessEdit: false,
    bookmasrList: [],
    isFollow: false,
    isLoginUser: false,
    isBusinessUserCheck: "",
    followersList: [],
    followingList: [],
    isUsersFollower: false,
    isSuccessBlock: false,
    blockeListUsers: [],
    isUserBlocked: false,
    isSearch: false,
    isCatch: false,
    showServerError: false,
    isDeleteProfile: false,
    businessAccountNameCheck: null,
    referringCode: 0,
    inviterID: 0,
    businessAccountName: "", //bara safe profile inviting link
    businessAccountNameByGetUSerInfo: "",//bara safe following inviting link
    messagesBadge: 0,
    NotifsBadge: 0,
    actions: {
        clearUserInfo: () => {
            set((state) => ({ userInfo: [] }));
        },

        setUserToken: async () => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrlWithoutApi}/User/SetUserToken`, {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    if (res.data.result.token) {
                        localStorage.setItem("veeuToken", res.data.result.token)
                        localStorage.setItem("veeuAuthData", res.data.result.code)
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },


        getBusinessAccountNameCheck: async (businessAccountName) => {
            await axios.post(`${baseUrlWithoutApi}/User/GetBusinessAccountNameCheck`, {
                "businessAccountName": businessAccountName,
            })
                .then((res) => {
                    set((state) => ({ businessAccountNameCheck: res.data }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        deleteUserProfileImage: async (userId) => {
            let body = {
                "userId": userId
            }
            await axios.delete(`${baseUrlWithoutApi}/User/DeleteUserProfileImage`,
                {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                    },
                    data: body
                },)
                .then((res) => {
                    set((state) => ({ userInfo: res.data }))
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterBookmarkByUserIdSearch: async (usrUserCode, searchQuery) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterBookmarkByUserId?UsrUserCode=${usrUserCode}&SearchQuery=${searchQuery}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ bookmasrList: res.data }))
                    set((state) => ({ loader: false }))
                    set((state) => ({ isSearch: true }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getUserInfoWithMobile: async (mobileNumber) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrlWithoutApi}/User/GetAllUser?MobileNumber=${mobileNumber}`)
                .then((res) => {
                    set((state) => ({ userInfoWithMobile: res.data }))
                    set((state) => ({ loader: false }))
                })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getUserInfo: async (useId) => {
            console.log(useId, "useId 12345678");

            const isNumeric = /^\d+$/.test(useId);
            console.log("isNumeric at User.jsx", isNumeric);
            if (isNumeric) {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrlWithoutApi}/User/GetAllUser?Id=${useId}`)
                    .then((res) => {
                        set((state) => ({ userInfo: res.data }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ businessAccountNameByGetUSerInfo: res.data[0]?.businessAccountName }))

                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })


            } else if (!isNumeric) {

                console.log("not numeriiiiicccccccccccccc");
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrlWithoutApi}/User/GetBusinessUserByBusinessAccountName?BusinessAccountName=${useId}`)
                    .then(res => {
                        set((state) => ({ userInfo: [res.data] }))
                        set((state) => ({ loader: false }))

                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })




            }
        },
        checkIsUserLogin: async (MobileNumber) => {
            await axios.get(`${baseUrlWithoutApi}/User/GetAllUser?MobileNumber=${MobileNumber}`)
                .then((res) => {
                    if (res.data.length) {
                        set((state) => ({ isLoginUser: true }))
                    } else {
                        set((state) => ({ isLoginUser: false }))
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        editUser: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrlWithoutApi}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        localStorage.setItem("veeuAuthData", res.data.id)
                        set((state) => ({ haveLike: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ isSuccessEdit: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessEdit: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        editUserWitoutToken: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrlWithoutApi}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            })
                .then((res) => {
                    if (res.status == 200) {
                        localStorage.setItem("veeuAuthData", res.data.id)
                        set((state) => ({ haveLike: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ isSuccessEdit: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessEdit: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        saveUserProfilelImage: async (userId, file) => {
            await axios.post(`${baseUrlWithoutApi}/User/SaveUserProfileImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`,
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        getAdsMasterBookmarkByUserId: async (useId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterBookmarkByUserId?UsrUserCode=${useId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ bookmasrList: res.data }))
                    set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        editAdsMasterBookmarkPin: async (usrUserCode, adsMasterCode) => {
            await axios.patch(`${baseUrl}/Advertise/EditAdsMasterBookmarkPin`, {
                "usrUserCode": usrUserCode,
                "adsMasterCode": adsMasterCode
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsUserFollow: async (userId, adsMasterUserId) => {
            await axios.post(`${baseUrlWithoutApi}/User/GetAdsUserFollow`, {
                "userId": userId,
                "adsMasterUserId": adsMasterUserId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ isFollow: true }))
                    } else (
                        set((state) => ({ isFollow: false }))
                    )
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getIsBusinessUser: async (userId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrlWithoutApi}/User/GetIsBusinessUser?UserId=${userId}`)
                .then((res) => {
                    set((state) => ({ isBusinessUserCheck: res.data }))
                    set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getUserFollowersList: async (userId, searchQuery) => {
            if (searchQuery) {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrlWithoutApi}/User/GetUserFollowersList`, {
                    "userId": userId,
                    "searchQuery": searchQuery
                })
                    .then((res) => {
                        set((state) => ({ isSearch: true }))
                        set((state) => ({ isUsersFollower: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followersList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrlWithoutApi}/User/GetUserFollowersList`, {
                    "userId": userId,
                })
                    .then((res) => {
                        set((state) => ({ isUsersFollower: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followersList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }

        },

        getUserFollowingList: async (userId, searchQuery) => {
            if (searchQuery) {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrlWithoutApi}/User/GetUserFollowingList`, {
                    "userId": userId,
                    "searchQuery": searchQuery
                })
                    .then((res) => {
                        set((state) => ({ isSearch: true }))
                        set((state) => ({ isUsersFollower: false }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followingList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrlWithoutApi}/User/GetUserFollowingList`, {
                    "userId": userId,
                })
                    .then((res) => {
                        set((state) => ({ isUsersFollower: false }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followingList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }

        },

        userBlockToggle: async (blockerUserId, userToBeBlockedId) => {
            await axios.post(`${baseUrlWithoutApi}/User/UserBlockToggle`, {
                "blockerUserId": Number(userToBeBlockedId),
                "userToBeBlockedId": Number(blockerUserId),

            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        set((state) => ({ isSuccessBlock: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessBlock: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        getUserBlockList: async (userId, searchQuery) => {
            set((state) => ({ loader: true }))
            if (searchQuery) {
                await axios.get(`${baseUrlWithoutApi}/User/GetUserBlockList?UserId=${userId}&SearchQuery=${searchQuery}`, {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                    },
                })
                    .then((res) => {
                        if (res.status == 200) {
                            set((state) => ({ loader: false }))
                            set((state) => ({ blockeListUsers: res.data }))
                        }
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                await axios.get(`${baseUrlWithoutApi}/User/GetUserBlockList?UserId=${userId}`, {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                    },
                })
                    .then((res) => {
                        if (res.status == 200) {
                            set((state) => ({ loader: false }))
                            set((state) => ({ blockeListUsers: res.data }))
                        }
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }
        },

        getIsUserBlocked: async (userId, token) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseUrlWithoutApi}/User/GetIsUserBlocked?UsertId=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then(async (res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ isUserBlocked: true }))
                    } else {
                        set((state) => ({ isUserBlocked: false }))
                    }
                    // set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getUserInit: async (userId) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseUrlWithoutApi}/User/UserInit?UserId=${localStorage.getItem("veeuAuthData")}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
                .then(async (res) => {
                    // console.log(res?.data?.referringCode, "res in getUserInit");
                    set((state) => ({ referringCode: res?.data?.referringCode }))
                    set((state) => ({ inviterID: res?.data?.id }))
                    set((state) => ({ businessAccountName: res?.data?.businessAccountName }))
                    set((state) => ({ messagesBadge: res?.data?.newMessages }))
                    set((state) => ({ NotifsBadge: res?.data?.newNotifications }))

                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
    }
}))
